var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useIsMounted } from "../../../../../../hooks/useIsMounted";
import { MinMaxForm } from "../../../../../Organisms";
import { FilterType, } from "../../../types";
import { AutocompleteFilter, DateFilter, LocationFilter, RadioFilter, } from "../../Organisms";
var ActiveFilter = function (_a) {
    var selectedFilter = _a.selectedFilter, onClose = _a.onClose, onSubmit = _a.onSubmit, isPercent = _a.isPercent, onClear = _a.onClear, values = _a.values, actionRef = _a.actionRef;
    var isMounted = useIsMounted();
    /**
     * This content is displayed in a parent popper, that parent popper doesnt know of this changing data
     * So we need to reposition it after the content is loaded, unfortunately the autocomplete content is
     * also in a popper so a timeout is used to give it a second for that additional popper to load so
     * the position is appropriately updated
     */
    useEffect(function () {
        setTimeout(function () {
            var _a;
            if (isMounted()) {
                (_a = actionRef === null || actionRef === void 0 ? void 0 : actionRef.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
            }
        }, 200);
    }, []);
    var parsedFilterType = selectedFilter.type.split("-")[0];
    /**
     * display the filter type thats currently selected
     */
    switch (parsedFilterType) {
        case FilterType.Range:
            return (_jsx(MinMaxForm, __assign({}, selectedFilter.options, { asChip: false, onClose: onClose, onSubmit: onSubmit, minName: "gte", onClear: onClear, maxName: "lte", isPercent: isPercent, values: (values === null || values === void 0 ? void 0 : values.range) || undefined })));
        case FilterType.Values:
            return (_jsx(AutocompleteFilter, __assign({ value: values === null || values === void 0 ? void 0 : values.values, onClear: onClear, onSubmit: onSubmit, actionRef: actionRef }, selectedFilter.options)));
        case FilterType.Location:
            return (_jsx(LocationFilter, __assign({ value: values, onClear: onClear, actionRef: actionRef, onSubmit: onSubmit }, selectedFilter.options)));
        case FilterType.Date:
            return (_jsx(DateFilter, __assign({ onClear: onClear, onSubmit: onSubmit, values: (values === null || values === void 0 ? void 0 : values[selectedFilter.type]) || undefined }, selectedFilter.options)));
        case FilterType.Radio:
            return (_jsx(RadioFilter, __assign({ onClear: onClear, onSubmit: onSubmit, value: (values === null || values === void 0 ? void 0 : values[selectedFilter.type]) || undefined }, selectedFilter.options)));
        default:
            return null;
    }
};
export default ActiveFilter;
